module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_1.e82f0ed6.png";